module.exports = __webpack_public_path__ + "static/media/Базовая станция.62d5f940.JPG";